<template>
    <section class="section pdv-page">
        <div class="level"><div><h1 class="title is-3">Categorias</h1></div>
            <b-button v-if="isInRole('pdv-categorias-alterar')" type="is-success" size="is-medium" icon-left="plus" @click="editar()">Nova categoria</b-button>
        </div>
        <div class="box">
            <b-field :message="mensagemPesquisa">
                <b-input v-model="procurar" placeholder="Nome da categoria" icon="magnify" @input="pesquisar"></b-input>
            </b-field>
            <b-table :data="categorias" :loading="carregando" striped hoverable paginated :per-page="15" :mobile-cards="true" empty-message="Nenhuma categoria cadastrada.">
                <b-table-column field="ordem" label="Ordem" width="90" centered v-slot="p">{{ p.row.ordem }}</b-table-column>
                <b-table-column field="nome" label="Nome" v-slot="p"><span class="tag" :style="{ backgroundColor: p.row.cor, color: contraste(p.row.cor) }">{{ p.row.nome }}</span></b-table-column>
                <b-table-column field="ativo" label="Ativa" centered v-slot="p"><b-tag :type="p.row.ativo ? 'is-success' : 'is-light'">{{ p.row.ativo ? 'Sim' : 'Não' }}</b-tag></b-table-column>
                <b-table-column label="Ações" centered v-slot="p"><b-button v-if="isInRole('pdv-categorias-alterar')" class="is-primary" size="is-small" icon-left="pencil" @click="editar(p.row)"></b-button></b-table-column>
            </b-table>
        </div>

        <b-modal :active="modal" @update:active="modal = $event" has-modal-card trap-focus>
            <ValidationObserver v-slot="{ handleSubmit }">
                <form class="modal-card" @submit.prevent="handleSubmit(salvar)">
                    <header class="modal-card-head"><p class="modal-card-title">{{ model.id ? 'Editar categoria' : 'Nova categoria' }}</p></header>
                    <section class="modal-card-body">
                        <ValidationProvider rules="required" name="Nome" v-slot="{ errors }"><b-field label="Nome" :type="errors.length ? 'is-danger' : null" :message="errors"><b-input :value="model.nome" maxlength="120" @input="normalizarNomeCategoria"></b-input></b-field></ValidationProvider>
                        <b-field label="Observação"><b-input type="textarea" maxlength="255" rows="2" v-model="model.observacao"></b-input></b-field>
                        <div class="columns"><div class="column"><b-field label="Cor"><b-input type="color" v-model="model.cor"></b-input></b-field></div>
                        <div class="column"><b-field label="Ordem"><b-input type="number" min="0" v-model.number="model.ordem"></b-input></b-field></div></div>
                        <b-switch v-model="model.ativo">Categoria ativa</b-switch>
                    </section>
                    <footer class="modal-card-foot"><b-button @click="modal = false">Cancelar</b-button><b-button native-type="submit" type="is-success" :loading="salvando">Salvar</b-button></footer>
                </form>
            </ValidationObserver>
        </b-modal>
    </section>
</template>

<script>
import http from '@/http'
import { mapState, mapGetters } from 'vuex'
export default {
    data: () => ({ categorias: [], procurar: '', timerPesquisa: null, pesquisaId: 0, carregando: false, salvando: false, modal: false, model: {} }),
    computed: {
        ...mapState(['unidadeId']),
        ...mapGetters(['isInRole']),
        mensagemPesquisa() {
            const tamanho = this.procurar.trim().length
            return tamanho > 0 && tamanho < 3 ? 'Digite pelo menos 3 caracteres para pesquisar.' : ''
        }
    },
    watch: { unidadeId: 'carregar' }, created() { this.carregar() },
    beforeDestroy() { clearTimeout(this.timerPesquisa) },
    methods: {
        pesquisar(valor) {
            clearTimeout(this.timerPesquisa)
            const termo = (valor || '').trim()
            if (termo.length > 0 && termo.length < 3) {
                this.pesquisaId++
                this.categorias = []
                this.carregando = false
                return
            }
            this.timerPesquisa = setTimeout(this.carregar, 300)
        },
        carregar() {
            if (!this.unidadeId) return
            const termo = this.procurar.trim()
            if (termo.length > 0 && termo.length < 3) return
            const pesquisaId = ++this.pesquisaId
            this.carregando = true
            http.get('/api/pdv/categorias', { params: { unidadeId: this.unidadeId, procurar: termo } })
                .then(r => { if (pesquisaId === this.pesquisaId) this.categorias = r.data })
                .catch(e => { if (pesquisaId === this.pesquisaId) this.erro(e) })
                .finally(() => { if (pesquisaId === this.pesquisaId) this.carregando = false })
        },
        editar(item) { this.model = item ? { ...item } : { id: 0, nome: '', observacao: '', cor: '#007bff', ordem: 0, ativo: true }; this.modal = true },
        normalizarNomeCategoria(valor) { this.$set(this.model, 'nome', (valor || '').toLocaleUpperCase('pt-BR')) },
        salvar() { this.normalizarNomeCategoria(this.model.nome); this.salvando = true; http.post('/api/pdv/categorias', this.model, { params: { unidadeId: this.unidadeId } }).then(() => { this.modal = false; this.carregar(); this.$buefy.toast.open({ message: 'Categoria salva.', type: 'is-success' }) }).catch(this.erro).finally(() => { this.salvando = false }) },
        erro(e) { this.$buefy.toast.open({ message: e.data?.erro || 'Não foi possível concluir a operação.', type: 'is-danger' }) },
        contraste(cor) { if (!cor || cor.length < 7) return '#fff'; const n = parseInt(cor.substring(1), 16); return (((n >> 16) * 299 + ((n >> 8) & 255) * 587 + (n & 255) * 114) / 1000) > 145 ? '#222' : '#fff' }
    }
}
</script>

<style scoped>
.pdv-page { padding: 0.5rem 0.5rem !important; }
</style>
